import { IPublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
import { ResourceInfo } from '../models/IConfig';

export class BaseService {
  resourceInfo: ResourceInfo;
  msalInstance: IPublicClientApplication;

  public constructor(resourceInfo: ResourceInfo, msalInstance: IPublicClientApplication) {
    this.resourceInfo = resourceInfo;
    this.msalInstance = msalInstance;
  }

  public async getAccessToken(): Promise<string> {
    const activeAccount = this.msalInstance.getActiveAccount();
    const accounts = this.msalInstance.getAllAccounts();
    if (!activeAccount && accounts.length === 0) {
      await this.msalInstance.loginRedirect();
      return '';
    }

    try {
      const tokenResponse = await this.msalInstance.acquireTokenSilent({
        scopes: [this.resourceInfo.resourceId],
        account: activeAccount || accounts[0],
      });
      return tokenResponse.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await this.msalInstance.acquireTokenRedirect({ scopes: [this.resourceInfo.resourceId] });
        return '';
      }
      throw error;
    }
  }
}
